import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { EMenuActions } from "../../store";
import ViewItems from "./viewItems";

const View = () => {
  let dispatch = useDispatch();

  const handleCloseReview = () => {
    dispatch(EMenuActions.setViewItems(false));
  };
  const handleNoPropagate = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      onClick={handleCloseReview}
      className="fixed w-[100%] h-[100vh] top-0 py-12 lg:py-12 lg:px-24 z-10 bg-dark/70"
    >
      <div
        className="w-full h-[80%] top-4 max-sm:m-auto "
        onClick={handleNoPropagate}
      >
        <div className="w-[90%] md:w-[50%] m-auto py-3 mt-5 rounded-t-sm items-center bg-secondary flex justify-between px-4">
          <h1 className="text-white font-bold flex justify-center">
            Items Order
          </h1>
          <div onClick={handleCloseReview} className="cursor-pointer">
            <FontAwesomeIcon icon={faTimes} size="2xl" className="text-black" />
          </div>
        </div>
        {/* body of the review questions */}
        <ViewItems />
      </div>
    </div>
  );
};
export default View;
